import { cn } from '@/lib/misc/Utils'

interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  cy?: string
}

const Toggle = ({ checked, onChange, disabled, cy }: ToggleProps) => (
  <label
    className="relative inline-flex items-center cursor-pointer"
    data-cy={cy}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => {
        if (disabled) return
        onChange(e.target.checked)
      }}
      disabled={disabled}
      className={cn('sr-only peer')}
    />
    <div
      className={cn(
        "w-11 h-6 bg-neutral-30 rounded-full peer transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-accent-60/30 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-surface after:rounded-full after:shadow-[0_1px_2px_rgba(28,28,31,0.2)] after:h-5 after:w-5 after:transition-transform peer-checked:bg-accent-60",
        disabled && 'cursor-not-allowed'
      )}
    />
  </label>
)

export default Toggle
